import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/contractornewmstatedef";




class ContractornewmstatedefService {

  editcontractornewmstatedef(data:any) {
    //console.log(query)
    return axios
      .put(API_URL, data)
      .then(response => {
        return response;
      });
  }

  addcontractornewmstatedef(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }
  contractornewmstatedefExist(name:string, id : number){
    return axios
      .post(API_URL + '/exist', {name: name, id : id})
      .then(response => {
        return response.data;
      });
  }

  deletecontractornewmstatedef(contractornewmstatedefId:number) {
    //console.log(query)
    return axios
      .delete(API_URL + '/'+ contractornewmstatedefId)
      .then(response => {
        return response.data;
      });
  }

  


  getcontractornewmstatedefs(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


 

}

export default new ContractornewmstatedefService();